var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('policy',{attrs:{"title":"Polityka prywatności","policy":_vm.templates[_vm.T.Privacy.CONTENT],"state":_vm.actions.templates}})}
var staticRenderFns = []

export { render, staticRenderFns }